import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { parseDiscoverEditorial } from './discoverEditorialData';

const EDITORIAL_PAGE_ID = 'discover-editorial';
const EDITORIAL_ASSET_PATH = 'content/pages/discover-editorial.json';

export const loadDiscoverEditorial = createAsyncThunk(
  'DiscoverEditorial/load',
  async (_arg, { dispatch, rejectWithValue }) => {
    try {
      const assets = await dispatch(
        fetchPageAssets({ [EDITORIAL_PAGE_ID]: EDITORIAL_ASSET_PATH }, false)
      );
      return parseDiscoverEditorial(assets?.[EDITORIAL_PAGE_ID]?.data);
    } catch (error) {
      // Keep diagnostics useful without logging request URLs or response payloads.
      const status = error?.status || error?.response?.status;
      console.error('Unable to load Discover editorial content.', {
        status: Number.isInteger(status) ? status : undefined,
      });
      return rejectWithValue({ code: 'EDITORIAL_ASSET_UNAVAILABLE' });
    }
  }
);

const discoverEditorialSlice = createSlice({
  name: 'DiscoverEditorial',
  initialState: { content: null, loading: false, error: null },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(loadDiscoverEditorial.pending, state => {
        state.content = null;
        state.loading = true;
        state.error = null;
      })
      .addCase(loadDiscoverEditorial.fulfilled, (state, action) => {
        state.content = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(loadDiscoverEditorial.rejected, (state, action) => {
        state.content = null;
        state.loading = false;
        state.error = action.payload?.code || 'EDITORIAL_LOAD_FAILED';
      });
  },
});

export const loadData = () => dispatch => dispatch(loadDiscoverEditorial());

export default discoverEditorialSlice.reducer;
